export default __webpack_public_path__ + "static/media/iqrf-logo-blue.758a417a.png";